import { Cookies } from 'typescript-cookie';
import { Answers } from '../Types/Types';
import { IsProductPage } from '../../FitAssistantShared/IsProductPage.js';

const COOKIE_NAME = 'cbs';

export const saveCbsAnswers = (answers: Answers): void => {
  const serialized = JSON.stringify(answers);
  Cookies.set(COOKIE_NAME, serialized, {
    expires: 365,
    secure: true,
    sameSite: 'strict',
  });
  if (IsProductPage) {
    const url = new URL(document.location.href);
    url.searchParams.set(COOKIE_NAME, serialized);
    history.replaceState(null, '', url.toString());
  }
};

export const loadCbsAnswers = (): Answers | null => {
  if (IsProductPage) {
    const qsValue = new URLSearchParams(window.location.search).get(COOKIE_NAME);
    if (qsValue) {
      try {
        return JSON.parse(decodeURIComponent(qsValue)) as Answers;
      } catch {
        // fall through to cookie
      }
    }
  }

  const cookieValue = Cookies.get(COOKIE_NAME);
  if (typeof cookieValue !== 'string') return null;
  try {
    return JSON.parse(cookieValue) as Answers;
  } catch {
    return null;
  }
};

export const removeCbsAnswers = (): void => {
  Cookies.remove(COOKIE_NAME);
  if (IsProductPage) {
    const url = new URL(document.location.href);
    url.searchParams.delete(COOKIE_NAME);
    history.replaceState(null, '', url.toString());
  }
};
